"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeFormatter = void 0;
const FALLBACK_STRING = "-";
const nativeFormatter = (formatService, format) => (value, language, options = {}) => {
    if (value == null) {
        return FALLBACK_STRING;
    }
    const result = formatService.format(value, format, language, options);
    // If the value is invalid for the specified format, i18next will return the
    // original value unmodified.
    if (typeof result !== "string") {
        return FALLBACK_STRING;
    }
    return result;
};
exports.nativeFormatter = nativeFormatter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmF0aXZlRm9ybWF0dGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL25hdGl2ZUZvcm1hdHRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFJQSxNQUFNLGVBQWUsR0FBRyxHQUFHLENBQUM7QUFXckIsTUFBTSxlQUFlLEdBQzFCLENBQWlDLGFBQTRCLEVBQUUsTUFBUyxFQUFxQixFQUFFLENBQy9GLENBQUMsS0FBYyxFQUFFLFFBQTRCLEVBQUUsVUFBNkQsRUFBRSxFQUFFLEVBQUU7SUFDaEgsSUFBSSxLQUFLLElBQUksSUFBSSxFQUFFLENBQUM7UUFDbEIsT0FBTyxlQUFlLENBQUM7SUFDekIsQ0FBQztJQUVELE1BQU0sTUFBTSxHQUFZLGFBQWEsQ0FBQyxNQUFNLENBQzFDLEtBQUssRUFDTCxNQUFNLEVBQ04sUUFBUSxFQUNSLE9BQW1ELENBQ3BELENBQUM7SUFFRiw0RUFBNEU7SUFDNUUsNkJBQTZCO0lBQzdCLElBQUksT0FBTyxNQUFNLEtBQUssUUFBUSxFQUFFLENBQUM7UUFDL0IsT0FBTyxlQUFlLENBQUM7SUFDekIsQ0FBQztJQUVELE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUMsQ0FBQztBQXJCUyxRQUFBLGVBQWUsbUJBcUJ4QiJ9